import {useSetAtom} from 'jotai';
import {useQueryClient} from '@tanstack/react-query';
import {clearData, saveToken, saveUserId} from 'src/services/storage';
import setLanguageCookie from '../setLanguageCookie';
import {userAtom} from './userAtoms';

export const useLogin = () => {
  const queryClient = useQueryClient();

  // @ts-ignore
  const setUser = useSetAtom(userAtom);

  const onLogin = (token: string, user: User) => {
    setUser({...user, token});
    saveToken(token);
    saveUserId(user._id);
    setLanguageCookie(user.language);
  };

  const updateUser = (updatedUser: User, language?: string) => {
    queryClient.invalidateQueries({queryKey: ['me']});
    setUser(updatedUser);

    if (language) setLanguageCookie(language);
  };

  const logOut = () => {
    setUser(null);
    queryClient.clear();
    clearData();
  };

  return {onLogin, updateUser, logOut};
};
